import React, { useEffect } from 'react';
import styles from './index.module.scss';
import HeroSection from './components/HeroSection';
import DonutChart from './components/DonutChart';
import MobileInvestigationDetails from './components/MobileInvestigationDetails';
import MapChart from './components/MapChart';
import VisitedRateTable from './components/VisitedRateTable';
import GameCTASection from './components/GameCTASection';
import ThemesSection from './ThemesSection';
import DataResourcesSection from './DataResourcesSection';
import ScrollTopBtn from './components/ScrollTopBtn';

const WORDING = {
    intro: "2022年9月18日14時44分，臺東池上發生規模6.8的極淺層地震（稱0918池上地震），深度7.8公里，最大震度在池上，達6強<sup>1</sup>。此次地震造成了花東地區許多建物與民宅遭受到不同程度的受損，甚至倒塌，並造成了1人死亡、171人受傷；在維生管線方面，自來水、電力與通訊也受到了損害，導致4,842處停水、22,024處停電，另有96處市話與25處基地台受到影響<sup>2</sup>。\n根據營建署截至2022年10月20日之資訊，0918池上地震後，花蓮及臺東兩縣收到通報的危險建築物計有840件，其中以花蓮671件，佔近八成為多，又後續經建築師與土木技師評定後，認定為紅色危險標誌者，計113件、黃色危險標誌者計119件<sup>3</sup>。",
    investigationTitle: "調查背景",
    investigationContent:
        "國家災害防救科技中心歷年來持續關注震前民眾的防減災對策、震時民眾的應變對策，以及震後民眾的損失衝擊，池上地震後隨即著手進行電話訪查，相關資訊如下說明：",
    investigationItems: [
        {
            title: "調查對象",
            content:
                "0918池上地震當時位於調查範圍內，且受訪當下年滿18歲以上的民眾",
        },
        {
            title: "調查家戶數",
            content: "震度4級地區1,562 戶<br/>震度5弱以上地區2,002戶",
        },
        {
            title: "調查時間",
            content: "2023.05~2023.07",
        },
        {
            title: "調查規劃",
            content: "國家災害防救科技中心",
        },
        {
            title: "調查執行",
            content: "典通股份有限公司",
        },
    ],
};

function EarthquakePage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.earthquakePage}>
            <ScrollTopBtn className={styles.scrollTopBtn} />
            <HeroSection />
            <div className={styles.content}>
                <div className={styles.wrapper}>
                    <div className={styles.intro}>
                        <p>
                            2022年9月18日14時44分，臺東池上發生規模6.8的極淺層地震（稱0918池上地震），深度7.8公里，最大震度在池上，達6強
                            <sup>1</sup>
                            。此次地震造成了花東地區許多建物與民宅遭受到不同程度的受損，甚至倒塌，並造成了1人死亡、171人受傷；在維生管線方面，自來水、電力與通訊也受到了損害，導致4,842處停水、22,024處停電，另有96處市話與25處基地台受到影響
                            <sup>2</sup>。<br />
                            根據營建署截至2022年10月20日之資訊，0918池上地震後，花蓮及臺東兩縣收到通報的危險建築物計有840件，其中以花蓮671件，佔近八成為多，又後續經建築師與土木技師評定後，認定為紅色危險標誌者，計113件、黃色危險標誌者計119件
                            <sup>3</sup>。
                        </p>
                    </div>
                    <h3 className={styles.investigationTitle}>
                        {WORDING.investigationTitle}
                    </h3>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: WORDING.investigationContent,
                        }}
                    />
                    <div className={styles.investigationItems}>
                        {WORDING.investigationItems.map((item) => (
                            <div
                                className={styles.investigationItem}
                                key={item.title}
                            >
                                <h4>{item.title}</h4>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: item.content,
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                    <MobileInvestigationDetails />
                    <DonutChart />
                    <MapChart />
                    <VisitedRateTable />
                </div>
                <GameCTASection />
                <ThemesSection />
                <DataResourcesSection />
            </div>
        </div>
    );
}

export default EarthquakePage;